// components/Accordion.tsx
import React from "react";
import { IoChevronDown } from "react-icons/io5";

type Props = {
    title: string;
    content: string | React.ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    /** Renders inline immediately after the title (e.g. info icon). Omit on accordions that do not need it. */
    titleSuffix?: React.ReactNode;
};

const Accordion: React.FC<Props> = ({ title, content, isOpen, onToggle, titleSuffix }) => {
    return (
        <div
            className={`bg-white rounded-3xl  overflow-hidden px-2
        ${isOpen ? "py-3" : "py-2"}`}
        >
            <button
                type="button"
                onClick={onToggle}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-2 px-3 py-3 text-[16px] font-semibold text-[#282828]"
            >
                <span className="flex min-w-0 flex-1 items-center gap-2 text-left">
                    <span className="truncate">{title}</span>
                    {titleSuffix}
                </span>
                <IoChevronDown
                    className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                        }`}
                />
            </button>
            <div
                className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                    }`}
            >
                <div className="overflow-hidden ">
                    <div className="px-3 pb-3 text-sm text-gray-600">{content}</div>
                </div>
            </div>
        </div>
    );
};

export default Accordion;
